































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { localStore } from '@/_utils/localstore'
import config from '@/_services/config'
import { DEFAULT_LOCALE } from '@/_consts/common'

@Component({
  components: {},
})
export default class LoginForm extends Vue {
  @Prop()
  disabledSubmit!: boolean

  unit: string = config.unit
  username: string = ''
  password: string = ''
  submitted: boolean = false
  isActive: boolean = false

  @Watch('unit')
  unitChange(): void {
    config.setUnit(this.unit)
  }

  getFieldType(fieldName) {
    return this.hasError(fieldName) ? 'is-danger' : ''
  }

  getIcon(fieldName) {
    return this.hasError(fieldName) ? 'alert' : 'check'
  }

  hasError(fieldName) {
    if (this.submitted && !fieldName) {
      return true
    }

    return false
  }

  // methods
  handleSubmit(): any {
    this.submitted = true
    const { username, password } = this
    const { dispatch } = this.$store
    if (username && password) {
      dispatch('authentication/login', { username, password })
    }
  }

  handleChangeLang(lang: string): void {
    this.$i18n.locale = lang
    localStore.setItem('lang', lang)
  }

  mounted() {
    localStore.clear()
    this.$nextTick(() => {
      this.$store.dispatch('resetAllModulesState', ['authentication'])
      this.$store.dispatch('resetAllModulesState')
    })
    this.unit = config.unit || ''
    localStore.setItem('lang', DEFAULT_LOCALE)
  }

  created() {
    this.$store.dispatch('authentication/getUnitList')
  }
}
